// monitor/src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";
import MonitorApp from "./App";
import AuthProvider from "./auth/AuthProvider";
import AuthenticatedMonitor from "./AuthenticatedMonitor";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root not found");
}

const root = ReactDOM.createRoot(rootElement);
const bypass = process.env.REACT_APP_AUTH_BYPASS === "true";
root.render(
  <React.StrictMode>
      {bypass ? (
      <MonitorApp />
    ) : (
      <AuthProvider>
        <AuthenticatedMonitor />
      </AuthProvider>
    )}
  </React.StrictMode>
);